import PropTypes from 'prop-types';
import { useState, useEffect, useCallback } from 'react';
// material
import {
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Typography,
  CircularProgress,
  Box,
  Divider,
  Button,
  DialogActions,
} from '@mui/material';
import { format } from 'date-fns';
// utils
import axios from '../../utils/axios';
import { HOST_API } from '../../config';

// ----------------------------------------------------------------------

MessageReceiptsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  chatId: PropTypes.string.isRequired,
  messageId: PropTypes.string.isRequired,
};

export default function MessageReceiptsModal({ open, onClose, chatId, messageId }) {
  const [receipts, setReceipts] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchReceipts = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.get(`/api/internal-chat/${chatId}/messages/${messageId}/receipts`);
      setReceipts(response.data);
    } catch (error) {
      console.error('Failed to fetch receipts', error);
    } finally {
      setLoading(false);
    }
  }, [chatId, messageId]);

  useEffect(() => {
    if (open && chatId && messageId) {
      fetchReceipts();
    }
  }, [open, chatId, messageId, fetchReceipts]);

  let content;
  if (loading) {
    content = (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
        <CircularProgress />
      </Box>
    );
  } else if (receipts.length === 0) {
    content = (
      <Typography variant="body2" sx={{ color: 'text.secondary', textAlign: 'center', py: 3 }}>
        Ninguém visualizou esta mensagem ainda.
      </Typography>
    );
  } else {
    content = (
      <List disablePadding>
        {receipts.map((receipt, index) => (
          <div key={receipt.user._id || index}>
            <ListItem disableGutters>
              <ListItemAvatar>
                <Avatar src={receipt.user.avatar ? `${HOST_API}${receipt.user.avatar}` : ''}>
                  {receipt.user.name?.charAt(0)}
                </Avatar>
              </ListItemAvatar>
              <ListItemText
                primary={receipt.user.name}
                secondary={receipt.readAt ? format(new Date(receipt.readAt), 'dd/MM/yyyy HH:mm:ss') : 'Lido'}
              />
            </ListItem>
            {index < receipts.length - 1 && <Divider component="li" />}
          </div>
        ))}
      </List>
    );
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Recibos de Leitura</DialogTitle>
      <DialogContent dividers>{content}</DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
